import { SelectField_default } from "./chunk-XW7X3DIL.js";
import { Select_Option_default } from "./chunk-EIUFV4NU.js";

// src/components/SelectField/index.tsx
var SelectFieldComponent = SelectField_default;
SelectFieldComponent.Option = Select_Option_default;
SelectFieldComponent.Option.displayName = "SelectField.Option";
export { SelectFieldComponent };